exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".strike {\n  text-decoration: line-through;\n}\n\n.productimg {\n  cursor: pointer;\n}\n\n.product--info {\n  margin-bottom: 25px;\n}\n\n.producttitle {\n  line-height: 22px;\n  overflow: hidden;\n}\n\n.producttitle.subtitle {\n  margin-top: 0px;\n  color: black;\n  font-size: 1em;\n  font-weight: normal;\n}\n\n.price--old {\n  margin-bottom: 0px;\n  font-weight: 300;\n  text-decoration: line-through;\n}\n\n.price {\n  margin-top: 0px;\n}\n\n.mini-logo {\n  position: absolute;\n  z-index: 9999;\n  top: 15px;\n  left: 15px;\n  height: 20%;\n}\n\n.list .productimg {\n  position: relative;\n  width: 30%;\n  margin-top: 20px;\n  margin-right: 0px;\n  padding-bottom: 200px;\n}\n\n.list .producttitle {\n  height: auto;\n}\n\n.grid .productimg {\n  width: 100%;\n  display: block;\n  padding-bottom: 150px;\n}\n\n.grid .price__holder {\n  height: 56px;\n  margin-bottom: 15px;\n}\n\n.grid .contentdiv {\n  float: none;\n  width: 100%;\n}\n\n.grid .contentdiv p {\n  height: 60px;\n  overflow: hidden;\n  margin: 10px 0;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/app/components/product/product.component.scss
// module id = ../../../../../src/app/components/product/product.component.scss
// module chunks = main